import { Typography } from '@mui/material'
import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Body() {
  const texts = useTexts()
  const {
    data: { driverAssignmentIds },
  } = useController()

  return <Typography>{texts.body(driverAssignmentIds.length)}</Typography>
}
